<template>
  <div>
    <ContentSpinner :show="!menuItems" />
    <div
      v-if="!loading && menuItems"
      id="modules"
    >
      <b-card
        v-for="menuItem of menuItems"
        :key="menuItem.moduleGuid"
        class="initial-flex mb-3"
        no-body
      >
        <template slot="header">
          <div
            class="header-toggle"
            @click="toggle(menuItem)"
          >
            <b>{{ menuItem.label }}</b>
            <font-awesome-icon
              :icon="['fas', moduleState[menuItem.moduleGuid].collapsed ? 'chevron-down' : 'chevron-up']"
              class="float-right"
            />
          </div>
        </template>
        <b-collapse :id="menuItem.moduleGuid">
          <Permissions
            v-if="!moduleState[menuItem.moduleGuid].collapsed"
            :modal-data="moduleState[menuItem.moduleGuid].data"
            :is-single-page="false"
          />
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>

import Permissions from '../../DataManagement/views/permissions/Permissions';
import ContentSpinner from '../../../core/components/ContentSpinner';
import {createNamespacedHelpers} from 'vuex';

const {mapState: sidebarMapState} = createNamespacedHelpers('sidebar');

export default {
  name: 'ModulesView',
  components: {
    Permissions,
    ContentSpinner,
  },
  data() {
    return {
      moduleList: [],
      moduleState: {},
      loading: true,
    };
  },
  watch: {
    menuItems() {
      this.setModuleList();
    },
  },
  computed: {
    ...sidebarMapState({
      menuItems: state => state.menuItems,
    }),
    modulesToRender() {
      return this.menuItems.sort((a, b) => a.isSystem ? -1 : 1);
    },
  },
  methods: {
    toggle(menuItem) {
      this.moduleState[menuItem.moduleGuid].collapsed = !this.moduleState[menuItem.moduleGuid].collapsed;
      this.$root.$emit('bv::toggle::collapse', menuItem.moduleGuid);
      this.moduleState = {...this.moduleState};
    },
    setModuleList() {
      this.menuItems.forEach((item) => {
        this.moduleState[item.moduleGuid] = {
          collapsed: true,
          data: {
            itemId: item.moduleGuid,
            type: 'module',
            name: item.label,
            data: null,
          },
        };
      });
    },
  },
  async mounted() {
    this.menuItems && await this.setModuleList();
    this.loading = false;
  },
};
</script>

<style scoped>

</style>